export type LandingLocale = 'vi' | 'en';

export type LandingCopy = {
  documentTitle: string;
  navPractice: string;
  navParents: string;
  navFaq: string;
  login: string;
  tryFree: string;
  tryFreeLong: string;
  imParent: string;
  heroEyebrow: string;
  heroTitleBefore: string;
  heroTitleHighlight: string;
  heroLead: string;
  trust1: string;
  trust2: string;
  trust3: string;
  mockTitle: string;
  mockLead: string;
  pillSpeaking: string;
  pillListening: string;
  pillRoleplay: string;
  pillWriting: string;
  practiceKicker: string;
  practiceTitle: string;
  practiceLead: string;
  card1Title: string;
  card1Body: string;
  card2Title: string;
  card2Body: string;
  card3Title: string;
  card3Body: string;
  parentsKicker: string;
  parentsTitle: string;
  parentsLead: string;
  parentsB1Title: string;
  parentsB1Body: string;
  parentsB2Title: string;
  parentsB2Body: string;
  parentsB3Title: string;
  parentsB3Body: string;
  tryForChild: string;
  faqNav: string;
  faqTitle: string;
  faq1Title: string;
  faq1Body: string;
  faq2Title: string;
  faq2Body: string;
  faq3Title: string;
  faq3BeforeTry: string;
  faq3BeforeLogin: string;
  faq3After: string;
  ctaTitle: string;
  ctaLead: string;
  tryNow: string;
  teacherLink: string;
  footerTagline: string;
  langVi: string;
  langEn: string;
  switchLanguage: string;
};

export const landingMarketingCopy: Record<LandingLocale, LandingCopy> = {
  vi: {
    documentTitle: 'Giỏi Tiếng Anh — Học tiếng Anh qua thực hành, tiến bộ từng ngày',
    navPractice: 'Cách học',
    navParents: 'Phụ huynh',
    navFaq: 'Hỏi đáp',
    login: 'Đăng nhập',
    tryFree: 'Dùng thử',
    tryFreeLong: 'Dùng thử miễn phí',
    imParent: 'Tôi là phụ huynh',
    heroEyebrow: 'Chào mừng bạn đến với Giỏi Tiếng Anh',
    heroTitleBefore: 'Học tiếng Anh bằng cách ',
    heroTitleHighlight: 'luyện thật nhiều.',
    heroLead:
      'Nói, nghe, viết và đóng vai trong các tình huống thường gặp. Sau mỗi lần làm bài, bạn biết ngay điểm cần sửa và có thể thử lại — không cần chờ đến buổi học sau.',
    trust1: 'Phù hợp học sinh từ trung học',
    trust2: 'Giáo viên vẫn giao bài và theo dõi lớp',
    trust3: 'Luyện lại ngay khi vừa mắc lỗi',
    mockTitle: 'Hôm nay bạn luyện gì?',
    mockLead:
      'Chọn một hoạt động và bắt đầu trong vài giây — tại nhà, trên điện thoại hoặc máy tính.',
    pillSpeaking: 'Luyện nói',
    pillListening: 'Nghe & chép chính tả',
    pillRoleplay: 'Hội thoại theo tình huống',
    pillWriting: 'Viết câu ngắn',
    practiceKicker: 'Cách học',
    practiceTitle: 'Một vòng lặp đơn giản: làm bài → nhận gợi ý → sửa → làm lại.',
    practiceLead:
      'Không cần am hiểu công nghệ. Bạn chỉ cần mở bài, thực hành và lắng nghe phản hồi để tiến bộ dần.',
    card1Title: 'Biết sai ở đâu ngay',
    card1Body:
      'Sau khi trả lời hoặc nói, bạn thấy gợi ý cụ thể thay vì chỉ biết đúng hay sai.',
    card2Title: 'Thử lại khi còn nhớ',
    card2Body: 'Luyện lại câu vừa sai giúp ghi nhớ lâu hơn so với chỉ đọc đáp án.',
    card3Title: 'Nhìn thấy tiến bộ',
    card3Body: 'Các lần luyện được ghi lại để bạn và giáo viên cùng theo dõi quá trình.',
    parentsKicker: 'Dành cho phụ huynh',
    parentsTitle: 'Cho con thêm giờ luyện chất lượng — không phải nơi “làm hộ bài”.',
    parentsLead:
      'Con cần tự nói, tự nghe và tự viết trước khi nhận gợi ý. Giáo viên vẫn là người giao bài và định hướng lộ trình trong lớp.',
    parentsB1Title: 'Học bằng thực hành',
    parentsB1Body: 'Con làm bài thật, không chỉ xem video hay đọc lý thuyết.',
    parentsB2Title: 'Gợi ý kịp thời',
    parentsB2Body: 'Giúp con sửa ngay khi còn nhớ bài vừa làm.',
    parentsB3Title: 'Gắn với lớp học',
    parentsB3Body: 'Bài tập và kết quả nằm trong quy trình giáo viên đã thiết lập.',
    tryForChild: 'Cho con dùng thử',
    faqNav: 'Hỏi đáp',
    faqTitle: 'Một vài điều phụ huynh và học sinh thường hỏi',
    faq1Title: 'Ai hướng dẫn nội dung học?',
    faq1Body:
      'Giáo viên giao bài và theo dõi lớp. Hệ thống hỗ trợ luyện tập và gợi ý sau khi học sinh làm bài.',
    faq2Title: 'Con có thể luyện những gì?',
    faq2Body: 'Nói, nghe, viết, trắc nghiệm và các bài tập tương tác theo chủ đề lớp đang học.',
    faq3Title: 'Bắt đầu từ đâu?',
    faq3BeforeTry: 'Bấm ',
    faq3BeforeLogin: ' để vào trang thực hành, hoặc ',
    faq3After: ' nếu giáo viên đã cấp tài khoản.',
    ctaTitle: 'Sẵn sàng luyện tiếng Anh hôm nay?',
    ctaLead:
      'Mở trang thực hành hoặc đăng nhập để vào lớp — mất vài phút, không cần cài đặt phức tạp.',
    tryNow: 'Dùng thử ngay',
    teacherLink: 'Bạn là giáo viên? →',
    footerTagline: 'Học tiếng Anh qua thực hành — dành cho học sinh và phụ huynh.',
    langVi: 'Tiếng Việt',
    langEn: 'English',
    switchLanguage: 'Chọn ngôn ngữ',
  },
  en: {
    documentTitle: 'Giỏi Tiếng Anh — Learn English through practice, one step at a time',
    navPractice: 'How it works',
    navParents: 'For parents',
    navFaq: 'FAQ',
    login: 'Log in',
    tryFree: 'Try it',
    tryFreeLong: 'Try for free',
    imParent: "I'm a parent",
    heroEyebrow: 'Welcome to Giỏi Tiếng Anh',
    heroTitleBefore: 'Learn English by ',
    heroTitleHighlight: 'practicing for real.',
    heroLead:
      'Speak, listen, write, and role-play everyday situations. After each attempt you see what to fix and can try again — no need to wait until the next class.',
    trust1: 'Great for secondary students',
    trust2: 'Teachers still assign work and follow the class',
    trust3: 'Retry while the mistake is still fresh',
    mockTitle: 'What will you practice today?',
    mockLead: 'Pick an activity and start in seconds — at home, on your phone, or on a laptop.',
    pillSpeaking: 'Speaking',
    pillListening: 'Listening & dictation',
    pillRoleplay: 'Situational role-play',
    pillWriting: 'Short writing',
    practiceKicker: 'How it works',
    practiceTitle: 'A simple loop: practice → feedback → fix → try again.',
    practiceLead:
      'No tech expertise needed. Open an activity, practice, and use feedback to improve step by step.',
    card1Title: 'Know what went wrong',
    card1Body: 'After you answer or speak, you get specific hints — not just right or wrong.',
    card2Title: 'Retry while you remember',
    card2Body: 'Repeating missed items helps more than reading the answer key once.',
    card3Title: 'See your progress',
    card3Body: 'Practice sessions are saved so you and your teacher can follow along.',
    parentsKicker: 'For parents',
    parentsTitle: 'Give your child more quality practice — not a shortcut to finished homework.',
    parentsLead:
      'Children speak, listen, and write before getting hints. Teachers still set assignments and guide the class.',
    parentsB1Title: 'Learning by doing',
    parentsB1Body: 'Real exercises, not only videos or reading theory.',
    parentsB2Title: 'Timely feedback',
    parentsB2Body: 'Helps children fix mistakes while the exercise is still fresh.',
    parentsB3Title: 'Tied to the classroom',
    parentsB3Body: 'Assignments and results stay in the flow your teacher set up.',
    tryForChild: 'Let my child try',
    faqNav: 'FAQ',
    faqTitle: 'Questions parents and students often ask',
    faq1Title: 'Who guides the learning content?',
    faq1Body:
      'Teachers assign work and monitor the class. The platform supports practice and feedback after students submit.',
    faq2Title: 'What can my child practice?',
    faq2Body: 'Speaking, listening, writing, quizzes, and interactive tasks aligned with class topics.',
    faq3Title: 'Where do we start?',
    faq3BeforeTry: 'Tap ',
    faq3BeforeLogin: ' to open the practice site, or ',
    faq3After: ' if the teacher already gave an account.',
    ctaTitle: 'Ready to practice English today?',
    ctaLead: 'Open the practice site or log in to your class — takes minutes, no complicated setup.',
    tryNow: 'Try now',
    teacherLink: 'Are you a teacher? →',
    footerTagline: 'English through practice — for students and parents.',
    langVi: 'Tiếng Việt',
    langEn: 'English',
    switchLanguage: 'Choose language',
  },
};
